/* eslint-disable import/no-cycle */
import api from './api.service';

function index(params) {
  return api.get('/settings/', params);
}

function store(params, config) {
  return api.post('/settings/', params, config);
}

export const settingsService = {
  index,
  store,
};
